export default "__VITE_ASSET__DkkA5Vj1__"